import React from 'react';

const featureGroups = [
  {
    category: "자료유출 방지",
    items: [
      { feature: "자료 해킹 방지", desc: "내장 하드디스크에 저장된 파일이 사용자 입력없이 네트워크나 외장 디스크로 유출되는 경우 차단" },
      { feature: "개인정보 포함 문서 해킹 방지", desc: "자료 유출 방지 시 개인정보가 포함 문서일 경우 구별하여 알림" },
      { feature: "자료 전송 감사로그", desc: "내장 하드디스크에 저장된 파일이 사용자 입력에 의해 네트워크나 외장 디스크로 전송되는 경우 로깅" },
      { feature: "개인정보 포함 문서 전송 감사로그", desc: "자료 전송 감사로그 시 개인정보가 포함 문서일 경우 구별하여 알림" },
      { feature: "메일·메신저 파일 첨부 차단", desc: "메일·메신저에 파일을 첨부하여 전송할 수 없도록 제한" },
      { feature: "메일·메신저 첨부파일 사이즈 제한", desc: "메일·메신저에 첨부하는 파일의 크기를 일정 사이즈 이내로 제한" },
      { feature: "출력문서 워터마크 삽입", desc: "프린트시 워터마크를 삽입하여 출력하도록 함 - 이미지 혹은 문자" },
      { feature: "인쇄기록 감사 로그", desc: "누가 언제 어떤 문서를 출력하였는지 히스토리 관리" },
    ],
  },
  {
    category: "랜섬웨어 공격 방지",
    items: [
      { feature: "순수 행위기반 차단 알고리즘", desc: "언노운 랜섬웨어 까지 방어 ( 유일 )" },
    ],
  },
  {
    category: "전자동 스마트백업",
    items: [
      { feature: "스마트 백업", desc: "+ CPU 유휴시간에만 백업 실행\n+ PC 사용 중에는 백업 중단\n+ 사용자 PC상태에 맞게 저장공간 크기 지정\n+ 저장공간이 부족할 경우 오래된 파일 자동 삭제\n+ 지정한 폴더 또는 파일만 백업되게 설정" },
      { feature: "전자동 백업", desc: "+ 사용자 개입 없이 스스로 알아서 백업\n+ 파일 생성 및 변경을 자동으로 인식하여 백업" },
      { feature: "자동 복원", desc: "+ 자동 복구툴 제공(복구툴에 의해서만 복구 가능)\n+ 원래 파일 경로 또는 지정 경로를 선택하여 복원" },
      { feature: "통합 관리 및 모니터링", desc: "+ 관리서버에서 개별사용자에 대한 백업정책 설정 가능\n+ 개별 사용자들의 백업상태를 관리서버에서 통합 모니터링" },
      { feature: "외부 저장장치로 백업", desc: "FTP / NAS 방식으로 외부 백업 지원" },
      { feature: "DB백업", desc: "Date Base 파일 백업 지원" },
    ],
  },
  {
    category: "좀비PC 방지",
    items: [
      { feature: "과다 트래픽 차단", desc: "사용자 입력없이 임계치(조절 가능) 이상의 트래픽이 발생할 경우 차단" },
    ],
  },
  {
    category: "매체사용 통제",
    items: [
      { feature: "USB장치 사용 통제", desc: "USB 매체를 사용/사용불가/Read만 가능하도록 설정하거나, 특정 USB만 허용할 수 있음" },
      { feature: "테더링 사용 통제", desc: "테더링 기능을 사용하지 못하게 막을 수 있음" },
      { feature: "블랙리스트기반 차단", desc: "블랙리스트 방식으로 특정 프로그램의 실행을 차단할 수 있음" },
      { feature: "인터넷 접속 통제", desc: "블랙리스트 방식으로 특정 웹사이트의 접속을 차단할 수 있음" },
    ],
  },
  {
    category: "이상징후 모니터링",
    items: [
      { feature: "PC uptime 모니터링", desc: "PC uptime을 모니터링하여 이상 가동 징후를 포착할 수 있음" },
      { feature: "웹페이지 접속기록 모니터링", desc: "웹페이지 접속기록을 모니터링하여 이상징후를 포착할 수 있음" },
      { feature: "리소스 사용량 모니터링", desc: "CPU, 메모리, 네트워크 등 사용량을 모니터링하여 이상징후를 포착할 수 있음" },
      { feature: "프로그램 설치 현황 모니터링", desc: "프로그램 설치 현황을 모니터링하여 악성코드 설치징후를 포착할 수 있음" },
      { feature: "개인정보 포함 문서 모니터링", desc: "개인정보 포함 문서 보유 상황을 모니터링하여 개인정보 보안에 대비할 수 있음" },
    ],
  },
];

const TrueEPMainFeatures = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>주요기능</h2>
      <div className={styles.divider} />

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th} style={{ width: 170 }}>구분</th>
              <th className={styles.th} style={{ width: 220 }}>제공 기능</th>
              <th className={styles.th}>trueEP만의 특장점</th>
            </tr>
          </thead>

          <tbody>
            {featureGroups.map((group, groupIdx) =>
              group.items.map((item, itemIdx) => (
                <tr key={`${groupIdx}-${itemIdx}`}>
                  {itemIdx === 0 && (
                    <td
                      className={styles.tdHead}
                      rowSpan={group.items.length}
                    >
                      {group.category}
                    </td>
                  )}
                  <td className={styles.td}>{item.feature}</td>
                  <td className={styles.desc}>{item.desc}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ul className={styles.bullets}>
        <li>
          단일 에이전트에 의한 <u>통합 보안 구현이 가능</u>합니다.
        </li>
      </ul>
    </section>
  )
}

export default TrueEPMainFeatures